import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';


import {LoginHelper, StringsHelper} from '../../helpers';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService, ProjectService, UserService,} from '../../_services/index';

@Component({
    standalone: false,
  selector: 'list-message-component',
  templateUrl: 'scoringReport.component.html',
  styleUrls: ['./scoringReport.component.scss']
})

export class ScoringReportComponent implements OnInit{
  report: any;
  project: any;
  clientLogo: string;
  consultantLogo: string;
  actionItemStatuses: any =
    {
      0: "Not Started",
      1: "In-Progress",
      2: "Resolved",
      3: "Awaiting Review",
      4: "Reviewed - Not POAM"
    };
  api = window.location.origin;

  constructor(
    public userService: UserService,
    public dialogRef: MatDialogRef<ScoringReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public projectService: ProjectService,
    public alertService: AlertService,
    public authenticationService: AuthenticationService) {
    this.project = data["project"];
    this.projectService.getScoringReportData(this.project.projectId).subscribe(d => {
      this.report = d;
      this.report.filteredControlItems =this.report.projectControlItems.filter(i => i.controlItem.parentControlItemId || !this.report.projectControlItems.find(c => c.controlItem.parentControlItemId == i.controlItem.controlItemId));
    })
  }

  ngOnInit(): void {
    this.userService.getPublicManagers(LoginHelper.getTenantName()).subscribe(managersInfo => {
      this.clientLogo = window.location.origin + '/api/attachments/file?name=' +encodeURIComponent((managersInfo.clientCompany || {}).logoFileName) + '&path=Account/System/' + '&token=' + LoginHelper.getFileToken();
      this.consultantLogo = (managersInfo.consultantCompany || {}).logoFileName ? (window.location.origin + '/api/attachments/file?name=' + encodeURIComponent((managersInfo.consultantCompany || {}).logoFileName) + '&path=Account/System/' + '&token=' + LoginHelper.getFileToken()) : '../assets/img/logo_light1.png';
    });
  }

  close(){
    this.dialogRef.close();
  }

  onLogOff(): void {
    this.dialogRef.close();
    this.authenticationService.logout();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getFullName(user) {
    return StringsHelper.getFullName(user);
  }

  print() {
    window.print();
  }
}
